import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Observable, Subject, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';



@Injectable()
export class DataBroadcastService {
   
    querySubjectBroadcast = new Subject();
    fontSizeBroadcast = new Subject();
    validateMassUpdateEnabled = new Subject();

    constructor(private http: HttpClient) {
        
    }

}
